<template>
  <div class="min-h-full flex">
    <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
      <div class="mx-auto w-full max-w-sm lg:w-96">
        <div>
          <img class="h-12 w-auto" src="/images/studio.svg" alt="St. Audio" />
          <h2 class="mt-6 text-3xl font-extrabold text-gray-900">
            Jetzt kostenlos beim St. Audio Studio anmelden
          </h2>
          <p v-if="!success" class="mt-2 text-sm text-gray-600">
            <router-link :to="{name: 'login'}" class="font-medium text-teal-600 hover:text-teal-500">
              Bereits registriert?
            </router-link>
          </p>
        </div>
        <div v-if="message" class="mt-8 bg-red-50 border-l-4 border-red-400 p-4">
          <p class="text-sm text-red-800" v-html="message" />
        </div>
        <div class="flex flex-col mt-8" v-if="success">
          <span>
            Vielen Dank für deine Registrierung. Bitte bestätige diese kurz mit einem Klick auf die E-Mail, die wir dir eben zugeschickt haben.
          </span>
          <router-link :to="{name: 'login'}" class="mt-8 button-submit">
            Zum Login
          </router-link>
        </div>
        <div v-else="success">
          <div class="mt-6">
            <div class="space-y-6">
              <SetupForm :resource="payload" :errors="errors" />
              <SubmitButton @click="onSubmit" :load="loading">
                Kostenlos registrieren
              </SubmitButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden lg:block relative w-0 flex-1">
      <img class="absolute inset-0 h-full w-full object-cover" src="/images/setup-3.png" alt="" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();

const action = 'auth/setup';
const loading = ref(false);
const success = ref(false);
const message = ref('');
const errors = ref({});

const payload = ref
({
  email: '',
  password: '',
  password_confirmation: '',
  terms: false,
  privacy: false,
  code: ''
});

const onSuccess = (result) =>
{
  loading.value = false;
  errors.value = {};
  message.value = null
  success.value = true;
  if(result.verified){
    store.dispatch("auth/reload").then(
      () => router.push({name: 'podcast.show'})
    )
  };
};

const onFailure = (error) =>
{
  loading.value = false;
  errors.value = (error?.errors) ?? [];
  message.value = (error?.message) ?? null;
  console.log("Account not created");
};

const onSubmit = () =>
{
  loading.value = true;
  store.dispatch(action, payload.value)
  .then(result => onSuccess(result))
  .catch(error => onFailure(error));
};
</script>
